// extracted by mini-css-extract-plugin
module.exports = {"bgicon":"project-module--bgicon--2KHqe"};